import { postRequest } from '@/common/libs/request';
import { setup } from '@tencent/tea-sdk-runner';

let tmpCode = '';

const setupMfaSdk = async () => {
  try {
    // 获取MFA所需要的Uin， OwnerUin
    const mfaInfo = await postRequest('/api/eda/common/mfa/describeMfaStatus', {
      interface: 'cvm:StopInstances',
    });
    // MFA初始化
    setup({
      // 是否需要获取控制台地域信息
      requireRegionData: false,
      // SDK 列表
      sdks: [
        {
          name: 'mfa-sdk',
          js: 'https://cloudcache.tencent-cloud.com/qcloud/tea/sdk/mfa.zh.dfe71110df.js?max_age=31536000',
          css: 'https://cloudcache.tencent-cloud.com/qcloud/tea/sdk/mfa.zh.a90950fdf9.css?max_age=31536000',
        },
      ],

      // 云 API 调用代理
      capi: async (body) => {
        // 查询MFA状态
        if (body.cmd === 'DescribeMfaStatus') {
          const res = await postRequest('/api/eda/common/mfa/describeMfaStatus', {
            interface: body.data.Interface,
          });
          // 需要MFA验证，直接返回云API数据
          if (res.mfaVerifyData.needAuth === 1) {
            tmpCode = res.mfaVerifyData.tmpcode;
            return {
              Response: {
                NeedAuth: res.mfaVerifyData.needAuth,
                AuthType: res.mfaVerifyData.authType,
                ExpireTime: res.mfaVerifyData.expireTime,
                AuthPhone: res.mfaVerifyData.authPhone,
                AuthHardToken: res.mfaVerifyData.authHardtoken,
                IsWeapp: res.mfaVerifyData.isWeapp,
                TmpCode: res.mfaVerifyData.tmpcode,
                Nickname: res.mfaVerifyData.nickname,
                HasOpenId: res.mfaVerifyData.hasOpenId,
                FaceIdType: null,
                Token: null,
                AuthEmail: res.mfaVerifyData.authEmail,
                Callback: null,
                Name: null,
                RequestId: 'd4ce1e6c-246e-4f6c-993f-48d315c92c09',
              },
            };
          }
        }
        // 查询MFA 微信扫码状态
        if (body.cmd === 'DescribeMfaCodeStatus') {
          const data = await postRequest('/api/eda/common/mfa/describeMfaCodeStatus', {
            tmpCode,
            interface: body.data.Interface,
          });
          return {
            Response: {
              Status: data.mfaWechatCodeStatusData.status,
              Tmpcode: data.mfaWechatCodeStatusData.Tmpcode,
              Nickname: data.mfaWechatCodeStatusData.Nickname,
              HasOpenId: data.mfaWechatCodeStatusData.HasOpenId,
              RmDevice: 0,
            },
          };
        }
        // 发送二维码
        if (body.cmd === 'SendSmsPassCode') {
          await postRequest('/api/eda/common/mfa/sendPhoneCode');
        }
        // 验证MFA
        if (body.cmd === 'VerifyFactor') {
          await postRequest('/api/eda/common/mfa/checkMfa', {
            interface: body.data.Interface,
            code: body.data.Code,
            authType: body.data.AuthType,
          });
          // this.showVerifyDialog(body.data.Interface);
        }
        return {
          Response: {
            NeedAuth: 0,
            AuthType: 0,
            ExpireTime: 0,
            AuthPhone: null,
            AuthHardToken: null,
            IsWeapp: 0,
            TmpCode: null,
            Nickname: null,
            HasOpenId: 1,
            FaceIdType: null,
            Token: null,
            AuthEmail: null,
            Callback: null,
            Name: null,
            RequestId: null,
          },
        };
      },
      // 自定义模块实现
      modules: {
        'foo/bar': {
          foo: '',
          bar: () => {},
        },
      },

      // 用户信息，用于复写控制台下 `window.LOGIN_INFO`
      loginInfo: {
        area: mfaInfo.area || 1,
        loginUin: mfaInfo.uin,
        ownerUin: mfaInfo.ownerUin,
      },
    });
  } catch (err) {
    console.log(err);
  }
};

export { setupMfaSdk };
